import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import styles from "./ActionDropdown.module.scss";

const ActionDropdown = ({ options = [] }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleActionClick = (action, disabled) => {
    if (!disabled && action) {
      action()
    }
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className={styles.actionDropdown}>
      <DropdownToggle caret className={styles.dropdownButton}>
        Action
      </DropdownToggle>
      <DropdownMenu className={styles["drop-down-menu"]}>
        {options?.length > 0 ? (
          options.map((item, index) => (
            <DropdownItem
              key={index}
              className={`${styles["dropdown-item"]} ${item.disabled ? styles.disabled : ""}`}
              onClick={() => handleActionClick(item.action, item.disabled)}
              disabled={item.disabled}
            >
              {item.label}
            </DropdownItem>
          ))
        ) : (
          <DropdownItem className={styles["dropdown-item"]}>
            No options
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ActionDropdown;